/**
 * Shared types and constants for the storefront URL boot-params platform
 * split (`boot-params.ts` native no-op / `boot-params.web.ts` web
 * implementation). Pure data — safe to import from any platform.
 */

/**
 * The web URL prefix for storefront microproducts: `/storefront/:productId`.
 *
 * `pages/[...slug].page.tsx` catch-alls every unmatched path to the app
 * shell, so this prefix only has to avoid the real Next.js pages
 * (`/plaid-link`, `/ftni/*`, `/loading`, `/healthz`, `/api/*`, `/_next/*`)
 * and the `/sales-portal` experience prefix — `/storefront` is free.
 */
export const STOREFRONT_PATH_PREFIX = '/storefront';

/**
 * A storefront deep-link intent parsed once from the boot URL
 * (`/storefront/:productId?restaurantUUID=...`).
 */
export interface StorefrontBootIntent {
  productId: string;
  restaurantUUID?: string;
}
